module.exports = __webpack_public_path__ + "img/features-bg_5.72fe8725.png";